<template>
  <v-dialog
    :modelValue="value"
    width="800"
    scrollable
    @update:modelValue="v => (v ? show() : close())"
  >
    <v-card flat class="rf-custom-web-card-wrapper">
      <v-card-title class="headline">Payload</v-card-title>
      <v-card-text class="code-preview">
        <component
          :is="codeEditor.CodeEditor"
          v-bind="{ ...codeEditor.props, languages: codeEditor.languages('json') }"
          :modelValue="codeValue"
          readOnly
        ></component>
      </v-card-text>
      <v-card-actions class="modal-card-actions-div">
        <v-btn class="cancel-btn" variant="outlined" width="100px" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiPaths from "@/apis/ApiPaths";
import { useToastsStore } from "@/pinia/toastsStore";
import { useAppsStore } from "@/pinia/appsStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";

export default {
  name: "RfDeviceApiPayloadModal",
  setup: () => ({
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
    appsStore: useAppsStore(),
    codeEditor: useCodeEditor(),
  }),
  data: () => ({ value: false, code: null, loading: false, language: null }),
  computed: {
    codeValue() {
      if (this.loading) return "// Loading...";
      if (!this.code) return "// No data";
      return this.code;
    },
  },
  methods: {
    show(language) {
      this.value = true;
      this.language = language;
      this.getPayload();
    },
    close() {
      this.value = false;
      this.language = null;
      this.code = null;
    },
    async getPayload() {
      try {
        this.loading = true;
        const data = await ApiPaths.livePaths(
          this.appsStore.app.id,
          [this.promptStore.prompt.id],
          this.language,
        );
        this.code = `${JSON.stringify(data[0], null, 2)}`;
      } catch (_e) {
        this.code = null;
        this.toastsStore.create({ type: "error", body: "Couldn't fetch data" });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.code-preview) {
  padding: 0 !important;
  display: flex;
}
</style>
